export default "__VITE_ASSET__LuwLqjMF__"